export default "__VITE_ASSET__8dee96f2__"